import { IApiService } from 'web_core_library';

export function createMigrationService() {
  let ApiService: IApiService;

  // this call creates a new cycle (must consist of one initial assessment session)
  const startMigration = () => {
    return ApiService.action('users_migrate_workouts', {
      method: 'post',
      urlParams: {
        userId: ApiService.getUserId(),
        migrationType: 'workouts',
      },
    });
  };

  const service = {
    init: (ApiServiceInstance: IApiService) => {
      ApiService = ApiServiceInstance;
    },
    startMigration,
  };
  return service;
}

const MigrationService = createMigrationService();
export default MigrationService;
